import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';
import { catchError, map } from 'rxjs/operators';
import { LoggerService } from '@app/blocks/logger/services/logger.service';
import { ConfigurationService } from '../shell/services/configuration.service';

@Injectable({
    providedIn: 'root'
})
export class ProfileService {

    constructor(
        private logger: LoggerService,
        private http: HttpClient,
        private configService: ConfigurationService,
    ) { }

    getAddress(userId: string): Observable<any> {
        const profilesApiUrl = this.configService.getConfig()?.shell.api.profilesApiUrl;
        return this.http.get<any>(`${profilesApiUrl}profiles/${userId}/address`).pipe(
            map(response => response || null),
            catchError(error => {
                // Handle error
                throw 'Error in getting address: ' + error;
            })
        );
    }

    getReviewFields(userId: string): Observable<any> {
        const profilesApiUrl = this.configService.getConfig()?.shell.api.profilesApiUrl;
        return this.http.get<any>(`${profilesApiUrl}profiles/${userId}/reviewfields`).pipe(
            map(response => response.data ? response.data : null),
            catchError(error => {
                // Handle error
                throw 'Error in getting reviewFields: ' + error;
            })
        );
    }

    updateProfile(userId: string, profile: any) {
        const profilesApiUrl = this.configService.getConfig()?.shell.api.profilesApiUrl;
        return this.http.put(`${profilesApiUrl}profiles/${userId}/update`, profile)
            .pipe(
                catchError(error => {
                    throw 'Error in delaying profile review: ' + error;
                })
            );
    }

    delayProfileReview(userId: string): Observable<any> {
        const profilesApiUrl = this.configService.getConfig()?.shell.api.profilesApiUrl;
        return this.http.put(`${profilesApiUrl}profiles/${userId}/delayreview`, null)
            .pipe(
                catchError(error => {
                    throw 'Error in delaying profile review: ' + error;
                })
            );
    }
}
